/**
 * Global Drawer Stack - Backward Compatibility Re-export
 * 
 * This file maintains backward compatibility with the original import path.
 * All functionality has been moved to packages/ui/src/components/global-stack/drawer/
 * 
 * @deprecated Use imports from '@west-tennessee-consulting/ui/components/global-stack' instead
 */

export * from "./global-stack/drawer/index.js";
